var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('dg-column',{attrs:{"gap":"xs"}},[_c('dg-text',[_vm._v(_vm._s(_vm.label))]),(!_vm.isScore)?_c('dg-text',{attrs:{"font-type":"body-highlighted"}},[_vm._v(_vm._s(_vm.value))]):_c('dg-score',{attrs:{"label":_vm.value,"state":_vm.state,"type":"inline"}}),_c('dg-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }